
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    heading: {
        borderBottom: '1px solid #000000'
    },

    root: {
        height: '100%',
        width: '1024px',
    },

    btn: {
        width: '49%'
    },

    btnBox: {
        padding: '1em 0em',
        display: 'flex',
        justifyContent: 'space-between'
    }
})

const SelectPricelistPageView = ({
    canContinue,
    onGoBackClick,
    onGoNextClick,
    pricelistEditor,
    selectFileForPricelist,
    selectPricelistType
}) => {

    React.useEffect(() => {
        document.getElementById('content').scrollTo(0, 0)
    }, [])

    const handleGoBackClick = () => {
        if (onGoBackClick) {
            onGoBackClick();
        }
    }

    const handleContinueClick = () => {
        if (onGoNextClick) {
            onGoNextClick();
        }
    }

    const previousIco = { iconName: 'TriangleLeft12' };
    const continueIco = { iconName: 'TriangleRight12' }

    return (
        <Stack verticalFill className={classNames.root}>
            <Stack.Item grow>
                {selectPricelistType}
            </Stack.Item>
            <Stack.Item grow>
                {selectFileForPricelist}
            </Stack.Item>
            <Stack.Item grow>
                {pricelistEditor}
            </Stack.Item>
            <Stack.Item className={classNames.btnBox}>
                <PrimaryButton iconProps={previousIco} className={classNames.btn} onClick={handleGoBackClick}>Zpět na zadání atributů pro úseky</PrimaryButton>
                {canContinue &&
                    <PrimaryButton iconProps={continueIco} className={classNames.btn} onClick={handleContinueClick}>Pokračovat na kalkulaci</PrimaryButton>
                }
            </Stack.Item>
        </Stack>
    )
}

export default SelectPricelistPageView;
